import React from "react";
import { RightPanel } from "../../../../../../components/RightPanel";
import { Equipment } from "./Equipment";
import { IBusinessPolicyEquipment } from "../../../../../../redux/businessPolicy/businessPolicyEquipment/businessPolicyEquipment.types";

interface IEquipmentRightPanelProps {
  open: boolean;
  customerId?: number;
  customerPolicyId?: number;
  equipmentNumber?: number;
  onSaveSuccess: (equipment: IBusinessPolicyEquipment) => void;
  staticStatusValue?: string;
  created_from?: string;
  readonly?: boolean;
  onClose: () => void;
  initialData?: IBusinessPolicyEquipment;
	disableApiCalls?: boolean;
}

export const EquipmentRightPanel: React.FC<IEquipmentRightPanelProps> = (
  props
) => {
  const {
	customerId,
	customerPolicyId,
	equipmentNumber,
	onClose,
	onSaveSuccess,
	readonly,
	staticStatusValue,
	created_from,
	initialData,
	disableApiCalls,
  } = props;

  return (
	<>
	  <RightPanel
		heading="Equipment"
		//subHeading="Add notes or comments"
		open={true}
		onClose={onClose}
		width="80%"
	  >
		<Equipment
		  customerId={customerId}
		  customerPolicyId={customerPolicyId}
		  equipmentNumber={equipmentNumber}
		  onSaveSuccess={onSaveSuccess}
		  readOnly={readonly}
		  fromRightPanel
		  staticStatusValue={staticStatusValue}
		  created_from={created_from}
		  initialData={initialData}
		  disableApiCalls={disableApiCalls}
		/>
	  </RightPanel>
	</>
  );
};
